import { Action } from 'redux';

export const CREATE_SUCURSAL_REQUEST = 'CREATE_SUCURSAL_REQUEST';
export const CREATE_SUCURSAL_SUCCESS = 'CREATE_SUCURSAL_SUCCESS';
export const CREATE_SUCURSAL_FAILURE = 'CREATE_SUCURSAL_FAILURE';

export const FETCH_SUCURSALES_REQUEST = 'FETCH_SUCURSALES_REQUEST';
export const FETCH_SUCURSALES_SUCCESS = 'FETCH_SUCURSALES_SUCCESS';
export const FETCH_SUCURSALES_FAILURE = 'FETCH_SUCURSALES_FAILURE';

export const FETCH_SUCURSAL_REQUEST = 'FETCH_SUCURSAL_REQUEST';
export const FETCH_SUCURSAL_SUCCESS = 'FETCH_SUCURSAL_SUCCESS';
export const FETCH_SUCURSAL_FAILURE = 'FETCH_SUCURSAL_FAILURE';

export const UPDATE_SUCURSAL_REQUEST = 'UPDATE_SUCURSAL_REQUEST';
export const UPDATE_SUCURSAL_SUCCESS = 'UPDATE_SUCURSAL_SUCCESS';
export const UPDATE_SUCURSAL_FAILURE = 'UPDATE_SUCURSAL_FAILURE';

export const DELETE_SUCURSAL_REQUEST = 'DELETE_SUCURSAL_REQUEST';
export const DELETE_SUCURSAL_SUCCESS = 'DELETE_SUCURSAL_SUCCESS';
export const DELETE_SUCURSAL_FAILURE = 'DELETE_SUCURSAL_FAILURE';

export const SET_SUCURSALES_PAGE = 'SET_SUCURSALES_PAGE';
export const SET_SUCURSALES_LIMIT = 'SET_SUCURSALES_LIMIT';

export interface CreateSucursalRequestAction extends Action<typeof CREATE_SUCURSAL_REQUEST> {
  type: typeof CREATE_SUCURSAL_REQUEST;
}

export interface CreateSucursalSuccessAction extends Action<typeof CREATE_SUCURSAL_SUCCESS> {
  type: typeof CREATE_SUCURSAL_SUCCESS;
  payload: any;
}

export interface CreateSucursalFailureAction extends Action<typeof CREATE_SUCURSAL_FAILURE> {
  type: typeof CREATE_SUCURSAL_FAILURE;
  payload: string;
}

export interface FetchSucursalesRequestAction extends Action<typeof FETCH_SUCURSALES_REQUEST> {
  type: typeof FETCH_SUCURSALES_REQUEST;
}

export interface FetchSucursalesSuccessAction extends Action<typeof FETCH_SUCURSALES_SUCCESS> {
  type: typeof FETCH_SUCURSALES_SUCCESS;
  payload: {
    data: any[];
    meta: {
      total: number;
      page: number;
      limit: number;
      totalPages: number;
    };
  };
}

export interface FetchSucursalesFailureAction extends Action<typeof FETCH_SUCURSALES_FAILURE> {
  type: typeof FETCH_SUCURSALES_FAILURE;
  payload: string;
}

export interface FetchSucursalRequestAction extends Action<typeof FETCH_SUCURSAL_REQUEST> {
  type: typeof FETCH_SUCURSAL_REQUEST;
}

export interface FetchSucursalSuccessAction extends Action<typeof FETCH_SUCURSAL_SUCCESS> {
  type: typeof FETCH_SUCURSAL_SUCCESS;
  payload: any;
}

export interface FetchSucursalFailureAction extends Action<typeof FETCH_SUCURSAL_FAILURE> {
  type: typeof FETCH_SUCURSAL_FAILURE;
  payload: string;
}

export interface UpdateSucursalRequestAction extends Action<typeof UPDATE_SUCURSAL_REQUEST> {
  type: typeof UPDATE_SUCURSAL_REQUEST;
}

export interface UpdateSucursalSuccessAction extends Action<typeof UPDATE_SUCURSAL_SUCCESS> {
  type: typeof UPDATE_SUCURSAL_SUCCESS;
  payload: any;
}

export interface UpdateSucursalFailureAction extends Action<typeof UPDATE_SUCURSAL_FAILURE> {
  type: typeof UPDATE_SUCURSAL_FAILURE;
  payload: string;
}

export interface DeleteSucursalRequestAction extends Action<typeof DELETE_SUCURSAL_REQUEST> {
  type: typeof DELETE_SUCURSAL_REQUEST;
}

export interface DeleteSucursalSuccessAction extends Action<typeof DELETE_SUCURSAL_SUCCESS> {
  type: typeof DELETE_SUCURSAL_SUCCESS;
  payload: string;
}

export interface DeleteSucursalFailureAction extends Action<typeof DELETE_SUCURSAL_FAILURE> {
  type: typeof DELETE_SUCURSAL_FAILURE;
  payload: string;
}

export interface SetSucursalesPageAction extends Action<typeof SET_SUCURSALES_PAGE> {
  type: typeof SET_SUCURSALES_PAGE;
  payload: number;
}

export interface SetSucursalesLimitAction extends Action<typeof SET_SUCURSALES_LIMIT> {
  type: typeof SET_SUCURSALES_LIMIT;
  payload: number;
}

export type SucursalesActionTypes =
  | CreateSucursalRequestAction
  | CreateSucursalSuccessAction
  | CreateSucursalFailureAction
  | FetchSucursalesRequestAction
  | FetchSucursalesSuccessAction
  | FetchSucursalesFailureAction
  | FetchSucursalRequestAction
  | FetchSucursalSuccessAction
  | FetchSucursalFailureAction
  | UpdateSucursalRequestAction
  | UpdateSucursalSuccessAction
  | UpdateSucursalFailureAction
  | DeleteSucursalRequestAction
  | DeleteSucursalSuccessAction
  | DeleteSucursalFailureAction
  | SetSucursalesPageAction
  | SetSucursalesLimitAction;